import React, {useEffect, useState} from 'react'
import { useHistory } from 'react-router';
import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import {TopBarRedesigned} from "../../../components/TopBarRedesigned";
import {
    Page,
    StatusBox,
} from "../../hygienist/ShiftDetailPage/ShiftDetail.styles";

import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import {
    ChatOutlined as ChatOutlinedIcon,
    LocalPhoneOutlined as LocalPhoneOutlinedIcon,
    Description as DescriptionIcon,
    InfoOutlined as InfoOutlinedIcon
} from '@mui/icons-material';

import Rating from '@mui/material/Rating';

import Api from "../../../api";
import {exitReact, formatProfileHygienistName, getPaymentMethod, getPaymentTerms, getPaymentType} from "../../../utils";
import _ from "lodash";
import useActionApi from "../../../hooks/useActionApi";

import { COUNTRY, JobPropsWithHygienist, PositionProps, SkillsProps } from "utils/types";

import {
    ConfirmedJobBox,
    DateTimeDescription,
    DescriptionContainer,
    HeaderDescription,
    LeftContainer,
    RightContainer,
    Subtitle,
    TitleContainer,
    Value,
    ValueBox,
    Link,
    ShiftDateIcon,
    BottomContainer,
    TopContainer,
    UserContainer,
    ConfirmedShiftIcon,
    CallBtn,
    MessageBtn,
    UnderlinedLink,
    ChangeShiftTimesBtn,
    HourlyRate,
    RateContainer, BookTempBtn,
    ButtonBox, ChangeShiftTimeBox,
} from "./ConfirmedOfferPage.styles";

import {
    StarIconActive,
    StarIconInactive,
} from "../../../components/ApplicationsList/ApplicationsList.styles";
import heartFilled from "../../../images/heartFilled.svg";
import heartUnfilled from "../../../images/heartUnfilled.svg";
import {Icon} from "../../hygienist/AvailableJobsPage/AvailableJobsPage.styles";
import {CancelShiftModal} from "./components/CancelShift";
import ProImage from "../../../components/Icons/ProImage";
import EliteImage from "../../../components/Icons/EliteImage";
import {SimpleModal} from "../../../components/Modal";
import {CannotCallModal, ModifyShiftModal} from "./components/Modals";
import {CollapsableContainer} from "../../../components/CollapsableContainer";
import styles from "../../hygienist/ShiftDetailPage/ShiftDetail.module.scss";
import TypographyFilled from "../../../images/Typography.png";
import Skills from "../CustomOfferDetailsPage/components/Skills";
import WorkFilled from "../../../images/WorkFilled.png";
import WorkExperience from "../CustomOfferDetailsPage/components/WorkExperience";
import AccountCircleFilled from "../../../images/AccountCircleFilled.png";
import TalentResume from "../../../components/TalentResume";
import Popup from "../../../components/Popup";

dayjs.extend(isToday)

const DentistConfirmedOfferPage = () => {
    const history = useHistory();
    const {id: jobId, job: jobData } = history.location.state as { id: number, job: JobPropsWithHygienist }
    const [job, setJob] = useState<JobPropsWithHygienist>(jobData)
    const [isCannotCallModalOpen, setIsCannotCallModalOpen] = useState(false)
    const [isResumeModalOpen, setIsResumeModalOpen] = useState(false)
    const [isModifyModalOpen, setIsModifyModalOpen] = useState(false)
    const [isFavouriteHygienist, setIsFavouriteHygienist] = useState(false)
    const [phone, setPhone] = useState<string | null>(null)
    const [workExperience, setWorkExperience] = useState<PositionProps[]>([])
    const [latestWorkExperience, setLatestWorkExperience] = useState<PositionProps>();
    const [apiSkills, setApiSkills] = useState<SkillsProps[]>([])

    const hygienist = job?.hygienist

    const lessThan2Hrs = dayjs(job?.shifts[0].shiftDate).diff(dayjs(), 'hours') < 2;

    const callBtn = lessThan2Hrs ? `Call: ${phone}` : 'Call'

    const [getJobDetailsLoading, , getJobDetails] = useActionApi({
        apiMethod: Api.getJobDetails,
        onSuccess: (jobObj: any) => {
            if(_.isEmpty(jobObj)) return
            setJob(jobObj)
            getResumeData({hygienistId: jobObj.hygienistId, locationId: jobObj.locationId})
        },
    });

    const [getSkillsLoading, , getSkills] = useActionApi({
        apiMethod: Api.getSkills,
        onSuccess: (skills: SkillsProps[]) => {
            if(_.isEmpty(skills)) return
            setApiSkills(skills)
        },
    });

    const [getResumeDataLoading, , getResumeData] = useActionApi({
        apiMethod: Api.getResumeData,
        onSuccess: (hygienist: any) => {
            setJob(job => ({...job, hygienist: hygienist}))
            setIsFavouriteHygienist(hygienist?.isFavouriteDentist)
            setWorkExperience(hygienist?.workExperience)
        },
    });

    useEffect(() => {
        if(_.isEmpty(jobData) && jobId) {
            getJobDetails(jobId)
        }
    }, [])

    useEffect(() => {
        if (job?.hygienist?.phone) {
            const justNumbers = job?.hygienist?.phone?.replace(/\D/g, '');
            const phoneNumber = justNumbers?.substr(0, 3) + '-' + justNumbers?.substr(3, 3) + '-' + justNumbers?.substr(6, 4);
            setPhone(phoneNumber)
        }
        if (job?.hygienist?.skills) {
            getSkills({type: job?.hygienist.type, state: job?.hygienist.province})
        }
    }, [job]);

    const goChat = () => {
        exitReact('chat', job, 'fwd', null)
    }

    const goCall = () => {
        if(lessThan2Hrs) {
            window.open(`tel:${phone}`, '_system')
            return
        } else {
            setIsCannotCallModalOpen(true)
        }
    }

    const hourlyRate = `$${job?.hourlyRate}/hr`

    const professionalLicense = _.isEmpty(hygienist) ? '' : formatProfileHygienistName(hygienist, hygienist?.skills);

    const goToModifyJob = () => {
        history.push('modifyJob', { job })
    }

    const bookAnotherHandler = () => {
        history.push('postJob', { date: dayjs(job.startDate).toISOString() })
    }

    useEffect(() => {
        if (workExperience) {
            let latestWorkExperience = workExperience.find((experience) => experience.current );
            if (!latestWorkExperience) {
                latestWorkExperience = workExperience.sort((a, b) => {
                    return dayjs(b.toDate).valueOf() - dayjs(a.toDate).valueOf();
                })[0]
            }
            setLatestWorkExperience(latestWorkExperience);
        }
    }, [workExperience]);

    return (<>
        {!_.isEmpty(job) ? <Page>
            <TopBarRedesigned
                title={'Booked/Confirmed Shift'}
                onBack={() => {
                    history.push('loading')
                    exitReact('home')
                }}
            />
            <SimpleModal isOpen={isCannotCallModalOpen}>
                <CannotCallModal firstName={hygienist.firstName} onCloseButtonClick={() => setIsCannotCallModalOpen(false)} />
            </SimpleModal>

            <SimpleModal isOpen={isModifyModalOpen}>
                <ModifyShiftModal firstName={hygienist.firstName} onSubmit={goToModifyJob} onCloseButtonClick={() => setIsModifyModalOpen(false)} />
            </SimpleModal>

            <Popup opened={isResumeModalOpen} onClose={() => setIsResumeModalOpen(false)}>
                <TalentResume hygienist={hygienist} onClose={() => setIsResumeModalOpen(false)} />
            </Popup>

            <HeaderDescription>
                {hygienist?.firstName} is booked and confirmed for your Dental
                {hygienist.type === 0 ? ' Hygienist' : ' Assistant'} shift on {dayjs(job.shifts[0].shiftDate).format('dddd, MMM D')}.
                They are looking forward to seeing your office and providing great care to your patients.
                Here are the details, a copy was sent to your account e-mail, so check your inbox:
            </HeaderDescription>
            <TitleContainer>
                <TopContainer>
                    <LeftContainer>
                        <Value>Shift Details</Value>
                        <Subtitle style={{opacity: 1}}>
                            <b>{job.location.practiceName} {job.location.address}</b>
                        </Subtitle>
                        <Subtitle style={{opacity: 1}}>
                            Temping Role: <b>Dental {hygienist.type === 0 ? ' Hygienist' : ' Assistant'}</b>
                        </Subtitle>
                        <Subtitle style={{opacity: 1}}>
                            Booked with: <b>{professionalLicense}</b>
                        </Subtitle>
                    </LeftContainer>

                    <RightContainer>
                        <Value>
                            <ShiftDateIcon />
                            {dayjs(job.shifts[0].shiftDate).format('dddd, MMM D')}
                        </Value>

                        <ValueBox>Start at: <Value>{job.shifts[0].postedStart}</Value></ValueBox>
                        <ValueBox>Shift ends: <Value>{job.shifts[0].postedEnd}</Value></ValueBox>

                        <DateTimeDescription>
                            {`*The start time is the time you expect ${hygienist.firstName} to be in the office, changed into their scrubs and ready to work, and is the start of paid time.`}
                        </DateTimeDescription>
                    </RightContainer>
                </TopContainer>
                <BottomContainer>
                    <ChangeShiftTimeBox>
                        <ChangeShiftTimesBtn
                            color={'secondary'}
                            variant={'outlined'}
                            onClick={() => setIsModifyModalOpen(true)}
                        >Change Shift Times</ChangeShiftTimesBtn>
                        <UnderlinedLink
                            href={'https://support.tempstars.com/hc/en-us/articles/26373358690195-I-Need-to-change-posted-shift-hours-Office-change-in-shift-schedule'}
                            target="_system" className={"external"}
                        >TempStars Shift Change Policy</UnderlinedLink>
                    </ChangeShiftTimeBox>
                    
                    <b style={{opacity: 0.6}}>You've agreed to pay {hygienist.firstName}: {getPaymentTerms(job.paymentTerms)} {job.paymentMethod ? `via ${getPaymentMethod(job.paymentMethod, job.location.country)}` : ''}</b>                    <UnderlinedLink href={'https://www.tempstars.com/direct_payment'} target="_system" className={"external"}>TempStars Payment Policy</UnderlinedLink>
                    {job.location.country === COUNTRY.US ? <b style={{opacity: 0.6, alignItems: 'center', display: 'flex'}}>
                            Working Relationship: {getPaymentType(job.paysW2)} <a href="https://www.tempstars.com/1099-w2/"
                                                                                  target="_system" className={"external"}>
                            <InfoOutlinedIcon className={styles.infoIcon}/></a>
                        </b>
                        : null}
                </BottomContainer>
            </TitleContainer>

            <UserContainer>
                <TopContainer>
                    <LeftContainer>
                        <ConfirmedJobBox>
                            <StatusBox>
                                <ConfirmedShiftIcon />
                                Confirmed
                            </StatusBox>
                        </ConfirmedJobBox>

                        <Value style={{display: 'flex', gap: '0.5rem'}}>
                            {professionalLicense}
                            <Icon style={{height: 22, alignSelf: 'center'}} src={isFavouriteHygienist ? heartFilled : heartUnfilled}/>
                            {hygienist?.status === 1 && <ProImage style={{display: 'flex', alignSelf: 'center', margin: 'unset'}} />}
                            {hygienist?.status === 2 && <EliteImage style={{display: 'flex', alignSelf: 'center', margin: 'unset'}} />}
                        </Value>

                        <Subtitle>
                            Graduated: {hygienist.graduationYear} from: {hygienist.school}
                        </Subtitle>

                        <Subtitle style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Rating
                                name="candidateRating"
                                value={hygienist.starScore}
                                readOnly
                                precision={0.01}
                                emptyIcon={<StarIconInactive />}
                                icon={<StarIconActive />}
                            />
                            <div>{hygienist.numRatedJobs} {hygienist.numRatedJobs === 1 ? 'Rating' : 'Ratings'}</div>
                        </Subtitle>

                        <ButtonBox>
                            <CallBtn
                                variant="outlined"
                                startIcon={<LocalPhoneOutlinedIcon/>}
                                color="primary"
                                size="large"
                                id="continue-button"
                                onClick={goCall}>
                                {callBtn}</CallBtn>
                            <MessageBtn
                                variant="outlined"
                                startIcon={<ChatOutlinedIcon/>}
                                color="primary"
                                size="large"
                                id="continue-button"
                                onClick={goChat}>
                                Messages</MessageBtn>
                        </ButtonBox>
                        <MessageBtn
                            variant="outlined"
                            startIcon={<DescriptionIcon />}
                            color="primary"
                            size="large"
                            id="continue-button"
                            onClick={() => setIsResumeModalOpen(true)}>
                            View Resume</MessageBtn>
                    </LeftContainer>

                    <RateContainer>
                        <ValueBox>Booked Rate:</ValueBox>
                        <HourlyRate>{hourlyRate}</HourlyRate>
                    </RateContainer>
                </TopContainer>
            </UserContainer>

            <div style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
            }}>
                <BookTempBtn
                    variant="contained"
                    color="primary"
                    onClick={bookAnotherHandler}
                >
                    Book Another Temp for this Date
                </BookTempBtn>
            </div>

            <CancelShiftModal
                job={job}
                onSubmit={() => history.push('loading')}
            />

            {hygienist?.skills && hygienist?.skills.length ? (
                <CollapsableContainer
                    title="Skills & Qualification"
                    defaultIsOpen={true}
                    icon={TypographyFilled}
                    backgroundColor="success"
                    noBorder={true}
                >
                    <p>{hygienist?.CDHONumber?.length
                        ? <b>{(hygienist?.type
                            ? 'Certificate #: ' : 'License #: ') + hygienist?.CDHONumber}</b>
                        : null}</p>
                    <Skills apiSkills={apiSkills} skills={hygienist?.skills} type={hygienist?.type} province={hygienist?.province}/>
                </CollapsableContainer>
            ) : null}

            {workExperience?.length ? <CollapsableContainer
                title="Work Experience"
                defaultIsOpen={true}
                icon={WorkFilled}
                backgroundColor={"alternate"}
                noBorder={true}
                preview={latestWorkExperience && <WorkExperience experiences={[latestWorkExperience]} />}
                fullPreview={true}
            >
                <WorkExperience experiences={workExperience} />
            </CollapsableContainer> : null}

            {hygienist?.about && <CollapsableContainer
                title="About Me"
                defaultIsOpen={true}
                icon={AccountCircleFilled}
                backgroundColor={"main"}
                noBorder={true}
                preview={hygienist?.about}
            >
                <p>{hygienist?.about}</p>
            </CollapsableContainer>}

            <DescriptionContainer>
                <Subtitle>
                    <b>Important Notes</b>
                </Subtitle>
                <Subtitle>
                    <b>Lunch and Breaks:</b> Generally lunches and breaks are unpaid time.
                    We know a workday at a dental office is unpredictable. But do ensure {hygienist?.firstName} gets an
                    appropriate break/lunch.
                    If the schedule is tight, discuss with {hygienist?.firstName} at the beginning of the shift so that expectations can be set.
                    <Link
                        href={'https://support.tempstars.com/hc/en-us/articles/360051065833-What-is-paid-time-and-unpaid-time'}
                        target="_system"
                        className={"external"}
                    >(TempStars policy on breaks and lunches)</Link>
                </Subtitle>
                <Subtitle>
                    <b>Start Time:</b> The "Start Time" is the time that {hygienist?.firstName} should be at your office, changed into scrubs and ready to work.
                    There is no expectation for them to be ready early for unpaid orientation. Ensure your Start Time takes prep/orientation time into consideration.
                    It makes for a hard day if your Start Time is the time your first patient is scheduled to be sitting in the chair
                    <Link
                        href={'https://support.tempstars.com/hc/en-us/articles/360052402253-Arrival-preparation-Time'}
                        target="_system"
                        className={"external"}
                    >(Learn more about Start Times)</Link>
                </Subtitle>
                <Subtitle>
                    <b>Directly Arranged Shifts:</b> If it goes well with {hygienist?.firstName} and want them to work future shifts, that's ok.
                    But remember you agreed to
                    <Link
                        href={'https://www.tempstars.com/direct_payment'}
                        target="_system"
                        className={"external"}
                    >(TempStars Policy for Direct Connections)</Link>
                    , so our placement fee applies to those shifts, as per the policy you agreed to.
                </Subtitle>
                <Subtitle>
                    <b>Hiring a TempStars Temp:</b> We don't charge for permanent hires: so if you have an opening on your team and want to hire {hygienist?.firstName} to your employee payroll...amazing!
                    We don't charge hiring or finders fees - we're just happy for the great connection.
                    You're welcome - it's one of the benefits of working with a company owned and lead by a practicing dentist.
                </Subtitle>
            </DescriptionContainer>

        </Page> : null}

        <FixedLoader
            loading={getJobDetailsLoading || getResumeDataLoading || getSkillsLoading}
        />
    </>)
}

export default DentistConfirmedOfferPage;
